<template>
  <div class="recap-pipeline">
    <b-row class="header-recap align-items-center">
      <b-col class="title" md="4" @click="handleClick">
        {{ title }}
      </b-col>
      <b-col class="text-semi-light" md="3" @click="handleClick">
        {{ description }}
      </b-col>
      <b-col md="1">
        <slot name="users"></slot>
      </b-col>
      <b-col class="buttons" md="4">
        <slot name="buttons"></slot>
      </b-col>
    </b-row>
    <h-p-container @click.native="handleClick">
      <slot name="list">
        <h-p-list
          v-for="(item, index) in content"
          :key="index"
          :container="false"
          :description="item.value"
          :title="item.name"
        >
        </h-p-list>
      </slot>
    </h-p-container>
  </div>
</template>

<script>
export default {
  name: 'recap',

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    content: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped></style>
